var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhoneIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 45 45",
  x: "0px",
  y: "0px",
  width: 45,
  height: 45,
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F28A2A",
  d: "M43.7 17.8c0 .4-.2.8-.5 1.1s-.7.5-1.1.5-.8-.2-1.1-.5-.5-.7-.5-1.1c0-3.5-1.4-7-3.9-9.5s-5.9-3.9-9.5-3.9c-.4 0-.8-.2-1.1-.5s-.5-.7-.5-1.1.2-.8.5-1.1.7-.5 1.1-.5c4.4 0 8.6 1.8 11.7 4.9 3.2 3.1 4.9 7.3 4.9 11.7",
  className: "st0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#5F1341",
  d: "m42.1 31.1-4.2-3.9c-1-1-2.4-1.5-3.8-1.5s-2.8.5-3.8 1.5L29 28.5l-.7-.3c-5.1-2.3-9.1-6.4-11.4-11.4l-.4-.8 1.3-1.3c1-1 1.6-2.4 1.6-3.8s-.5-2.8-1.5-3.8l-4-4.3c-1-1-2.4-1.5-3.7-1.5-1.4 0-2.8.5-3.8 1.5l-1 .9c-.4.2-.7.5-.9.6l-.2.2C1.4 7.8.7 11.9 1.6 16.2S5 25 8.4 29.2s7.8 7.9 12.1 10.5c4.4 2.6 8.7 4.1 12.2 4 1.4 0 2.8-.3 4.2-.8 1.3-.5 2.5-1.3 3.5-2.3l.2-.2c.2-.2.4-.5.7-.8l.9-1c1-1 1.5-2.4 1.5-3.8s-.6-2.8-1.6-3.7m-2.2 5.3c-.1.1-.1.1-.1.2l-.1.1c-.2.2-.4.5-.6.7s-.4.5-.6.7l-.3.3v.1h-.1c-3 2.7-7.2 2.4-11.3.9-4.2-1.6-8.6-4.7-12.4-8.3-3.8-3.7-7-8-8.7-12.2-1.7-4.3-2-8.7.7-12l.1-.1.1-.1.3-.3c.1-.1.4-.3.6-.5.3-.2.5-.4.7-.6l.2-.2s.1 0 .1-.1c.4-.4.9-.6 1.4-.6s1.1.1 1.5.5h.1l4.1 4.4c.2.2.4.4.5.7s.2.6.2.9-.1.6-.2.8-.3.5-.5.7l-2 2.1c-.2.2-.4.5-.4.8-.1.3 0 .6.1.9 1.3 3.6 3.4 6.8 6.1 9.5s6 4.8 9.5 6.1c.3.1.6.1.9.1.3-.1.6-.2.8-.4l2.2-2.2h.1c.3-.2.8-.6 1.5-.5.6 0 1.1.4 1.4.6l4.2 3.9q.6.6.6 1.5c-.1.7-.3 1.2-.7 1.6",
  className: "st1"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F28A2A",
  d: "M34.4 17.8c0 .4-.2.8-.5 1.1s-.7.5-1.1.5-.8-.2-1.1-.5-.5-.7-.5-1.1c0-1.1-.4-2.1-1.2-2.8-.8-.8-1.8-1.2-2.8-1.2-.4 0-.8-.2-1.1-.5s-.5-.7-.5-1.1.2-.8.5-1.1.7-.5 1.1-.5c1.9 0 3.8.8 5.1 2.1 1.3 1.4 2.1 3.2 2.1 5.1",
  className: "st0"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhoneIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/phone-icon.226500353e159078ad3180c3633d830c.svg";